<template>
  <div class="admin-tab">
    <wb-datatable
      v-bind="tableProps"
      @addEmit="openCreateDialog"
      @editEmit="openUpdateDialog"
      @deleteEmit="openConfirmDialog"
      :searchKey="'email'"
    ></wb-datatable>
    <md-dialog ref="createDialog">
      <md-dialog-title>Create user</md-dialog-title>

      <md-dialog-content>
        <form>
          <md-input-container>
            <label>Name</label>
            <md-input v-model="newUser.user.name"></md-input>
          </md-input-container>
          <md-input-container>
            <label>Email</label>
            <md-input v-model="newUser.user.email"></md-input>
            <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
          </md-input-container>
          <md-input-container v-if="isQuinyx">
            <label>User ID</label>
            <md-input v-model="newUser.user.id"></md-input>
          </md-input-container>
          <md-input-container>
            <label for="selectedApp">Select an application</label>
            <multiselect id="userEmail"
                         v-model="selectedApp"
                         :options="appsCopy"
                         :multiple="false"
                         :close-on-select="true"
                         :clear-on-select="false"
                         placeholder="Application Name"
                         label="Name"
                         @input="selectRoleByAppId(selectedApp)"
            >
            </multiselect>

            <!--<md-select name="selectedApp" id="selectedApp" v-model="newUser.appId">-->
              <!--<md-option @click.native="selectRoleByAppId(app.id)" v-for="(app, index) in apps" :value="app.id" :key="index">{{app.Name}}</md-option>-->
            <!--</md-select>-->
          </md-input-container>
          <md-input-container>
            <label for="role">Set a role</label>
            <md-select :disabled="!newUser.appId" name="role" id="role" v-model="newUser.role">
              <md-option v-if="roles" v-for="(role, index) in roles" :value="role" :key="index">{{role}}</md-option>
            </md-select>
          </md-input-container>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeCreateDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeCreateDialog(true)">Create</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog ref="updateDialog">
      <md-dialog-title>Update User</md-dialog-title>

      <md-dialog-content>
        <form v-if="user">
          <md-input-container>
            <label>User name</label>
            <md-input v-model="user.username"></md-input>
          </md-input-container>
          <md-input-container>
            <label>Email</label>
            <md-input v-model="user.email"></md-input>
          </md-input-container>
          <md-input-container>
            <label>Team ID</label>
            <md-input v-model="user.teamId"></md-input>
          </md-input-container>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <div v-if="user && user.status !== 'Activated'">
          <md-button class="md-primary" @click="resendActivationEmail(user.email)">Resend activation email</md-button>
        </div>
        <md-button class="md-primary" @click="closeUpdateDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeUpdateDialog(true)">Update</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog ref="confirmDialog">
      <md-dialog-title>Are you sure you would like to remove this user?</md-dialog-title>

      <md-dialog-content>
        User will permanently be removed from the database
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
        <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import wbDataTable from 'WBDataTable';
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import _ from 'underscore';
import Multiselect from 'vue-multiselect';
import managedata from '../../helpers/managedata';
import utils from '../../helpers/utils';

export default {
  name: 'AdminUsers',
  components: {
    'wb-datatable': wbDataTable,
    Multiselect
  },
  data() {
    return {
      user: null,
      newUser: {
        user: {
          name: null,
          email: null
        },
        appId: null,
        role: null
      },
      tableProps: {
        dataext: [],
        columns: null,
        hasControls: true,
        allowCreation: true,
        disableSearch: false,
        pagination: {
          size: 50
        },
      },
      appsCopy : [],
      selectedApp : null,
      tableColumns: [
        {name: 'id', displayName: 'ID', visible: true, type:'number', isEditable:false},
        {name: 'name', displayName: 'Name', visible: true, type:'string', isEditable:false},
        {name: 'username', displayName: 'Username', visible: true, type:'string', isEditable:false},
        {name: 'email', displayName: 'Email', visible: true, type:'string', isEditable:false},
        {name: 'status', displayName: 'Status', visible: true, type:'string', isEditable:false},
      ],
      errorMessage: ''
    }
  },
  validations: {
    newUser: {
      user: {
        name: { required },
        email: { required },
      },
      appId: { required },
      role: { required }
    }
  },
  computed: {
    ...mapGetters([
      'userStatuses',
      'users',
      'apps',
      'roles'
    ]),
    isQuinyx(){
      return utils.isQuinyx();
    }
  },
  methods: {
    selectRoleByAppId(app) {
      let id = app.id;
      this.$store.dispatch('getRolesById', { id });
      this.newUser.role = null;
      this.newUser.appId = id;
    },
    getUsers() {
      this.$store.dispatch('getUserStatuses')
        .then(() => {
          return this.$store.dispatch('getUsers')
        })
        .then(() => {
          this.$store.commit('START_REQUEST');
          const clonedUsers = JSON.parse(JSON.stringify(this.users));
          this.tableProps.dataext = [];
          this.$nextTick(() => {
            this.tableProps.dataext = clonedUsers;
          });
          this.$store.commit('FINISH_REQUEST');

          this.$store.dispatch('getApps')
              .then(() => {
                  this.appsCopy = JSON.parse(JSON.stringify(this.apps)).map(e => {
                      if (e.environment) {
                          e.Name = `${e.Name} (${e.environment})`;
                      }
                      return e;
                  });
                  this.appsCopy.sort((a, b) => {
                      if (a.Name > b.Name) return 1;
                      if (a.Name < b.Name) return -1;
                      return 0;
                  });
              });
        });
    },
    openCreateDialog() {
      this.$refs.createDialog.open();
    },
    closeCreateDialog(isSaved) {
      const u = this.newUser;
      if (isSaved) {
        if (u.user.name !== null && u.user.name.length > 0
          && u.user.email !== null && u.user.email.length > 0
          && u.appId !== null
          && u.role !== null) {
            if(utils.isQuinyx()){
              u.id = u.user.id
            }
              this.$store.dispatch('createUserFromApp', {
                user: u
              }).then(resp => {
                  if (resp.body.message) {
                      this.errorMessage = resp.body.message;
                  } else {
                      this.errorMessage = '';
                      this.getUsers();
                      this.$refs.createDialog.close();
                  }
              });
          }
      } else {
        this.$refs.createDialog.close();
      }
    },
    openUpdateDialog(row, columns) {
      if (row) {
        this.user = Object.assign({}, row);
      } else {
        this.user = null;
      }
      this.$refs.updateDialog.open();
    },
    closeUpdateDialog(isSaved) {
      if (isSaved) {
        this.$store.dispatch('updateUser', this.user)
          .then(() => {
            this.getUsers();
          });
      }
      this.$refs.updateDialog.close();
      this.user = null;
    },
    openConfirmDialog(row) {
      this.user = row;
      this.$refs.confirmDialog.open();
    },
    closeConfirmDialog(isConfirmed) {
      if (isConfirmed) {
        this.$store.dispatch('deleteUser', this.user)
          .then(() => {
            this.getUsers();
          })
      }
      this.$refs.confirmDialog.close();
    },
    resendActivationEmail(email) {
      managedata.resendKey(email).then(res => {
          this.$store.commit('CLEAR_MESSAGE');
          this.$store.commit({
            type: 'SET_MESSAGE',
            message: 'Email was successfully sent'
          });
        }).catch(err => {
          console.log(err);
          this.$store.commit('CLEAR_MESSAGE');
          this.$store.commit({
            type: 'SET_MESSAGE',
            message: 'Something went wrong. Please try again later.'
          });
        });
    }
  },
  mounted() {
    this.tableProps.columns = this.tableColumns;
    this.getUsers();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-input-container .md-error {
    display: block !important;
    left: 0;
    bottom: -30px;
    color: red;
     opacity: 1;
    transform: translate3d(0, -8px, 0);
    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);
  }
</style>



// WEBPACK FOOTER //
// AdminUsers.vue?39bfd6d0